<div
  class="segmented-filter"
  [class.segmented-filter--tabs]="isTabs()"
  [class.segmented-filter--compact]="density() === 'compact'"
  [attr.role]="isTabs() ? 'tablist' : 'radiogroup'"
  [attr.aria-label]="ariaLabel()"
  data-testid="segmented-filter"
>
  @for (item of items(); track item.id; let i = $index) {
    <button
      type="button"
      class="segmented-filter__button"
      [class.segmented-filter__button--active]="isActive(item)"
      [attr.role]="isTabs() ? 'tab' : 'radio'"
      [attr.aria-checked]="isTabs() ? null : isActive(item)"
      [attr.aria-selected]="isTabs() ? isActive(item) : null"
      [attr.tabindex]="isActive(item) ? 0 : -1"
      [attr.data-testid]="item.testId ?? null"
      [attr.id]="buttonId(item)"
      [attr.aria-controls]="isTabs() ? controls() : null"
      (click)="onSelect(item.id)"
      (keydown)="onKeydown($event, i)"
    >
      @if (item.icon) {
        <mat-icon class="segmented-filter__icon" aria-hidden="true">{{ item.icon }}</mat-icon>
      }
      <span>{{ item.label }}</span>
      @if (item.count !== undefined && item.count !== null) {
        <span class="segmented-filter__count" [class.segmented-filter__count--active]="isActive(item)">
          {{ item.count }}
        </span>
      }
    </button>
  }
</div>
